import {CONSONANT_VOWEL_PAIRS_N} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_n";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_N_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_N} title="Consonant-Vowel Pairs: ㄴ (n)" />
     </>
);}